export default __webpack_public_path__ + "static/media/retake-recording.ad2911d5.svg";